import { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const THU_VIET = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const getAssetBase = () => {
  if (typeof window !== "undefined" && window.keobongvipPlugin?.assetBase) {
    return String(window.keobongvipPlugin.assetBase).replace(/\/$/, "");
  }
  return PUBLIC_URL;
};

const buildDateOptions = (today, mode) => {
  const options = [];

  if (mode !== "past") {
    const assetBase = getAssetBase();
    options.push({
      value: "live",
      label: "Trực Tiếp",
      icon: `${assetBase}/hot-icon.svg`,
    });
  }

  options.push({ value: today.format("YYYY-MM-DD"), label: "Hôm nay" });

  if (mode === "past") {
    for (let i = 1; i <= 7; i++) {
      const d = today.clone().subtract(i, "day");
      const thu = THU_VIET[d.day()];
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: `${thu} (${d.format("DD/MM")})`,
      });
    }
    return options;
  }

  for (let i = 1; i <= 7; i++) {
    const d = today.clone().add(i, "day");
    const thu = THU_VIET[d.day()];
    options.push({
      value: d.format("YYYY-MM-DD"),
      label: `${thu} (${d.format("DD/MM")})`,
    });
  }
  return options;
};

const KbvDateRange = ({ value, onChange, className = "", mode = "future" }) => {
  const today = dayjs().tz(TZ);
  const options = useMemo(() => buildDateOptions(today, mode), [today, mode]);

  return (
    <div className={`flex items-center overflow-x-auto pb-4 gap-2.5 ${className}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`hover:brightness-110 inline-flex items-center gap-1 px-2 py-1.5 rounded text-sm items-center justify-center font-medium transition-colors cursor-pointer rounded-full whitespace-nowrap shrink-0
             ${ "live" == opt.value ? "min-w-[100px]" : ""}
             
             ${ today.format("YYYY-MM-DD") == opt.value ? "min-w-[80px]" : ""}

             ${value === opt.value
              ? "bg-[var(--theme-primary)] text-white font-semibold"
              : "bg-[var(--theme-bg)] text-[var(--theme-text)] font-medium"
            }`}
        >
          {opt.icon && (
            <img src={opt.icon} alt="" className="w-4 h-4 object-contain" />
          )}
          
          <span className="text-sm font-medium">{opt.label}</span>
          
        </button>
      ))}
    </div>
  );
};

export default KbvDateRange;
